import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('unidades-negocios'), opciones);
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`unidades-negocios/${id}`));
  },
};
